__turbopack_context__.v({
  "container": "Loading-module__5VDP-q__container",
  "fadeInItems": "Loading-module__5VDP-q__fadeInItems",
  "spacing--lg": "Loading-module__5VDP-q__spacing--lg",
  "spacing--md": "Loading-module__5VDP-q__spacing--md",
  "spacing--sm": "Loading-module__5VDP-q__spacing--sm",
  "spacing--xl": "Loading-module__5VDP-q__spacing--xl",
  "spacing--xs": "Loading-module__5VDP-q__spacing--xs",
  "spacing--xxl": "Loading-module__5VDP-q__spacing--xxl",
  "spacing--xxs": "Loading-module__5VDP-q__spacing--xxs",
  "spacing--xxxl": "Loading-module__5VDP-q__spacing--xxxl",
  "spacing--xxxs": "Loading-module__5VDP-q__spacing--xxxs",
});
